import React from 'react';
// Assuming your CSS is moved to a folder accessible by the component
import '../style/manual_Essentials.css'; 
import { NavLink } from 'react-router-dom';



export default function  ManualTesterSkills  () {
  return (
    <div className="min-h-screen bg-gray-100 font-poppins">
   
      {/* Hero Banner */}
      <section className="hero-guide-banner">
        <div className="hero-content">
          <div className="hero-icon-container">
            <i className="fas fa-lightbulb"></i>
          </div>
          <h1>Essential Skills for Manual Testers</h1>
          <p>
  Essential skills for manual testers, including analytical thinking,
  communication, domain understanding, defect reporting, and test design.
</p>

        </div>
      </section>

      {/* Tabs */}
      {/* NAV TABS */}
      <nav className="nav-tabs">
        <NavLink to="/software-testing"  className="active">
          <i className="fa-solid fa-book-open"></i> Overview
        </NavLink>

        <NavLink to="/testing-types">
          <i className="fa-solid fa-box"></i> Types
        </NavLink>

        <NavLink to="/testing-pyramid">
          <i className="fa-solid fa-puzzle-piece"></i> Pyramid
        </NavLink>

        <NavLink to="/testing-methods" >
          <i className="fa-solid fa-code"></i> Methods
        </NavLink>

        <NavLink to="/testing-practices">
          <i className="fa-solid fa-lightbulb"></i> Practices
        </NavLink>

        <NavLink to="/testing-tools">
          <i className="fa-solid fa-screwdriver-wrench"></i> Tools
        </NavLink>
      </nav>

    <main className="content">
  <aside className="sidebar">
          <h3>Guide Navigation</h3>
          <ul>
            <li><a href="#what-is-it">What is Integration Testing?</a></li>
            <li><a href="#why-done">Why Integration Testing is Done</a></li>
            <li><a href="#when-done">When Integration Testing is Done</a></li>
            <li><a href="#how-done">How Integration Testing is Done</a></li>
            <li><a href="#benefits">Benefits & Disadvantages</a></li>
            <li><a href="#summary">Short Interview-Style Summary</a></li>
            <li><a href="#comparison">Comparison Table</a></li>
            <li><a href="#conclusion">Conclusion</a></li>
          </ul>
          <hr />
          <p style={{ marginTop: '15px' }}>
            <NavLink to="/software-testing" style={{ color: '#007bff', fontWeight: '600' }}>
              ← Back to Software Testing
            </NavLink>
          </p>
        </aside>

           <NavLink to="/manual-testing"><strong>← Back to Manual Testing</strong></NavLink>
        <h1>Essential Skills for Manual Testers</h1>
        <p className="intro">Develop analytical, communication, and domain knowledge skills.</p>

        <div className="accordion">
            <div className="accordion-item">
                <button className="accordion-header">Problem-solving Skills</button>
                <div className="accordion-body">
                 <h3>Software Testing Basics</h3>
                    <p>Testers often encounter unexpected challenges. Strong problem-solving skills enable them to
                        troubleshoot issues, reproduce defects, and identify the root cause, leading to efficient
                        resolutions and improved quality.</p>
                </div>
            </div>

            <div className="accordion-item">
                <button className="accordion-header">Analytical Skills</button>
                <div className="accordion-body">
                    <p>A tester must possess strong analytical skills to thoroughly understand project requirements,
                        identify potential problem areas, and create effective test scenarios and cases. This helps
                        ensure comprehensive coverage of the software’s functionalities.</p>

                </div>
            </div>

            <div className="accordion-item">
                <button className="accordion-header">Communication Skills</button>
                <div className="accordion-body">
                    <p>Effective communication is crucial for testers. They need to clearly report bugs, explain
                        complex issues to developers, and communicate with business analysts and stakeholders to
                        ensure mutual understanding of requirements and results.</p>

                </div>
            </div>

            <div className="accordion-item">
                <button className="accordion-header">Domain Knowledge</button>
                <div className="accordion-body">
                    <p> Understanding the business domain helps testers evaluate whether the software aligns with
                        real-world user needs and business logic. Domain expertise makes testing more focused,
                        relevant, and effective.</p>

                </div>
            </div>


            <div className="accordion-item">
                <button className="accordion-header">Attention to Detail</button>
                <div className="accordion-body">
                    <p>Manual testers must be meticulous and detail-oriented to identify even minor defects that
                        could impact the end-user experience. A sharp eye ensures that nothing slips through
                        unnoticed.</p>

                </div>
            </div>
     
            <div className="accordion-item">
                <button className="accordion-header">Essential Skills for Manual Testers</button>
                <div className="accordion-body">
                    <ul>
                        <li><strong>Analytical Skills:</strong> Understanding requirements and designing effective test
                            cases.</li>
                        <li><strong>Attention to Detail:</strong> Identifying small but critical defects.</li>
                        <li><strong>Communication Skills:</strong> Collaborating with teams effectively.</li>
                        <li><strong>Domain Knowledge:</strong> Understanding business context for accurate validation.
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </main>
    </div>
  );
};

